import { Component, Input, inject } from '@angular/core';
import { ReportDownloaderComponent } from '../report-downloader/report-downloader.component';
import { ReportService } from '../report-filters/services/report.service';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'stx-report-header',
  templateUrl: './report-header.component.html',
  imports: [MatIcon, ReportDownloaderComponent]
})
export class ReportHeaderComponent {
  reportService = inject(ReportService);

  @Input()
  reportDownloaderEnabled = true;

  toggleFiltersVisibility() {
    this.reportService.toggleFiltersVisibility();
  }
}
